import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


import { useLocalStorage } from "../../../hooks";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";



import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import { Info } from "lucide-react";
import moment from "moment";
import { TwButton, TwDialog, TwFormHelperText, TwInputGroup, TwLabel, TwPopover, TwRadioBox, TwSelectGroup, TwTextarea } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";

export default function PurchaseSessionPopover({
  view = "product",
  purchasingDetails,
  myMembersDetail,
  customerInfo,
  reloadData,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userToken] = useLocalStorage("userToken");
  const dashboardReduxState = useSelector(dashboardState);
  const [openCancelSubscriptionDialog, setOpenCancelSubscriptionDialog] = React.useState(false);
  const [openRefundClasspassDialog, setOpenRefundClasspassDialog] = React.useState(false);

  const {
    purchaseId,
    selectedPassDetail,
    paymentStatus,
    paymentMethod,
  } = purchasingDetails;

  const cancelsubscription = () => {
    setOpenCancelSubscriptionDialog(true)
  }

  const refundclasspass = () => {
    setOpenRefundClasspassDialog(true)
  }

  const viewDetails = () => {
    navigate("/purchase/view", {
      state: {
        passId: selectedPassDetail.passId,
        purchaseId: purchaseId
      },
    })
  }

  let popoverOptions = [
    // {
    //   text: "View Details",
    //   onClick: viewDetails,
    //   disabled: false,
    // },
    ...
    selectedPassDetail.productType === "subscription" ? [{
      text: "Cancel subscription",
      onClick: cancelsubscription,
      disabled: selectedPassDetail.isCancel != undefined && selectedPassDetail.isCancel == true ? true : false,
    }] : (paymentStatus == "Paid" && parseFloat(selectedPassDetail.price) > 0 ? [
      {
        // text: "Refund payment",
        text: "Remove/Cancel Product",
        onClick: refundclasspass,
        // disabled: selectedPassDetail.isCancel != undefined && selectedPassDetail.isCancel == true ? true : false,
        disabled: ((selectedPassDetail.isCancel != undefined && selectedPassDetail.isCancel == true)
          || (selectedPassDetail.refund != undefined && selectedPassDetail.refund.isRefunded != undefined && selectedPassDetail.refund.isRefunded == true)
          // || (paymentMethod == "Cash")
        ) ? true : false,
      }
    ] : [])];


  return (

    <div>
      {popoverOptions.length > 0 && (<TwPopover
        buttonClassName={""}
        buttonContent={(<EllipsisVerticalIcon aria-hidden="true" className="size-5" />)}
      >
        <div className={"flex flex-col divide-y divide-gray-200"}>
          <label className="block text-sm/6 font-semibold text-gray-900 px-2 py-1">
            Actions
          </label>
          {popoverOptions.map((opt, idx) => (
            <button
              key={idx}
              disabled={opt.disabled}
              className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}
              onClick={opt.onClick}
            >
              {opt.text}
            </button>
          ))}
        </div>
      </TwPopover>)}
      {openCancelSubscriptionDialog == true && (<CancelSubscriptionDialog
        openCancelSubscriptionDialog={openCancelSubscriptionDialog}
        setOpenCancelSubscriptionDialog={setOpenCancelSubscriptionDialog}
        purchasingDetails={purchasingDetails}
        reloadData={reloadData}
      />)}

      {openRefundClasspassDialog == true && (<RefundClasspassDialog
        openRefundClasspassDialog={openRefundClasspassDialog}
        setOpenRefundClasspassDialog={setOpenRefundClasspassDialog}
        purchasingDetails={purchasingDetails}
        myMembersDetail={myMembersDetail}
        customerInfo={customerInfo}
        reloadData={reloadData}
      />)}
    </div>
  );
}


export function CancelSubscriptionDialog({
  openCancelSubscriptionDialog,
  setOpenCancelSubscriptionDialog,
  purchasingDetails,
  reloadData,
}) {
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userToken] = useLocalStorage("userToken");
  const dashboardReduxState = useSelector(dashboardState);
  const loadingReduxState = useSelector(loadingState);
  const [formErrors, setFormErrors] = React.useState({});
  const [formValues, setFormValues] = React.useState({
    cancelType: "immediately",
    refund: "no_refund",
  });
  const defaultrefundOptions = [
    { id: 'no_refund', value: 'no_refund', title: 'No refund' },
    // { id: 'pro_rated_amount', value: 'pro_rated_amount', title: `Pro-rated amount €3.93 of €4.00` },
  ]
  const [refundOptions, setRefundOptions] = React.useState(defaultrefundOptions);


  const {
    purchaseId,
    selectedPassDetail,
    paymentStatus,
  } = purchasingDetails;


  const getStripeInvoicePreview = async () => {

    const invoicePreviewConfig = {
      method: "post",
      url: `${getUrlForBookings()}getStripeInvoicePreview`,
      data: {
        purchase_id: purchasingDetails._id
      }
    };
    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));

    const invoicePreviewRequest = await axiosInstance(invoicePreviewConfig);
    dispatch(setGlobalLoading(false));
    dispatch(setActionLoading(false));
    if (invoicePreviewRequest.status === 200) {
      if (invoicePreviewRequest.data.statusCode === 200 && invoicePreviewRequest.data.data.id) {
        let preview = invoicePreviewRequest.data.data
        const refundAmount = preview.total < 0 ? ((-preview.total) / 100) : 0;
        let refundOptionsList = [
          ...defaultrefundOptions,
        ]
        if (invoicePreviewRequest.data.data.latestInvoice && invoicePreviewRequest.data.data.latestInvoice.paid == true) {
          refundOptionsList.push({ id: 'pro_rated_amount', value: 'pro_rated_amount', title: `Pro-rated amount €${parseFloat(refundAmount).toFixed(2)} of €${parseFloat(selectedPassDetail.price).toFixed(2)}` })
        }
        setRefundOptions(refundOptionsList)
      }
    }
  };

  const cancelProductSubscription = async (data, status) => {
    const config = {
      method: "post",
      url: `${getUrlForBookings("")}cancelProductSubscription`,
      data: {
        purchase_id: purchasingDetails._id,
        cancelType: formValues.cancelType,
        refund: formValues.refund
      }
    };
    // console.log(config);
    // return;

    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const newsFeedRequest = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    dispatch(setActionLoading(false));
    if (newsFeedRequest.status === 200) {
      setFormErrors({})
      addNotificationDialog({
        dialogType: "success",
        dialogTitle: "Success!",
        dialogMessage: "Your subscription cancelled successfully.",
        dialogBackdropClick: async () => {
          reloadData()
        },
        dialogBtnClick: async () => {
          reloadData()
        }
      })

      setOpenCancelSubscriptionDialog(false)
    } else {
      addErrorToast("Something is wrong please try again")
    }
  };

  useEffect(() => {

    (async () => {
      if (openCancelSubscriptionDialog == true) {
        if (selectedPassDetail.isCancel != undefined && selectedPassDetail.isCancel == true) {
          setOpenCancelSubscriptionDialog(false)
          addErrorToast("This subscription is already canceled")
        } else {
          if (paymentStatus == "Paid") {
            await getStripeInvoicePreview()
          }
        }
      }

    })()
  }, [openCancelSubscriptionDialog, paymentStatus])



  return (

    <TwDialog
      dialogTitle={"Cancel subscription"}
      dialogOpen={openCancelSubscriptionDialog}
      isFullContent={true}
      onClose={(v) => { setOpenCancelSubscriptionDialog(false) }}
    >
      <div className="flex flex-col w-full gap-5">
        <div className="flex gap-2 w-full">
          <TwLabel className="min-w-20">Cancel</TwLabel>
          <div className="flex-1 flex gap-2">

            <TwRadioBox
              // title={"Cancel Type"}
              name={"cancelType"}
              displayStyle="list"
              disabled={loadingReduxState.actionLoading}
              value={formValues.cancelType}
              onChange={(e) => {
                const { name, value, checked } = e.target;
                setFormValues((prevValues) => ({
                  ...prevValues,
                  [name]: value,
                  ...(value == "end_of_the_current_period") ? { refund: "no_refund" } : {}
                }));
              }}
              radioList={[
                { id: 'immediately', value: 'immediately', title: <div className="flex flex-col gap-0">Immediately <span className="text-gray-400">{moment().format('DD-MMM-YYYY')}</span></div> },
                { id: 'end_of_the_current_period', value: 'end_of_the_current_period', title: <div className="flex flex-col gap-0">End of the current period <span className="text-gray-400">{moment(purchasingDetails.purchaseExpiredDate).format('DD-MMM-YYYY')}</span></div> },
              ]}
              errors={formErrors} />
          </div>
        </div>
        <div className="w-full border-b border-gray-400"></div>
        <div className="flex gap-2 w-full">
          <TwLabel className="min-w-20">Refund</TwLabel>
          <div className="flex-1 flex gap-2">

            <TwRadioBox
              // title={"Cancel Type"}
              name={"refund"}
              displayStyle="list"
              disabled={loadingReduxState.actionLoading || paymentStatus != "Paid"}
              value={formValues.refund}
              onChange={(e) => {
                const { name, value, checked } = e.target;
                setFormValues((prevValues) => ({
                  ...prevValues,
                  [name]: value,
                }));
              }}
              radioList={formValues.cancelType == "immediately" ? refundOptions : defaultrefundOptions}
              errors={formErrors} />
          </div>
        </div>
        {formErrors["general"] && (
          <TwFormHelperText error={true}>{formErrors["general"]}</TwFormHelperText>
        )}
        <div className={"flex gap-4 justify-center pt-5 w-full sm:w-full sm:max-w-sm md:max-w-lg"}>
          <TwButton
            variant={"brown-coffee-outline"}
            // className={"w-full"}
            disabled={loadingReduxState.actionLoading}
            onClick={() => {
              setOpenCancelSubscriptionDialog(false)
            }}
          >
            Don't cancel
          </TwButton>
          <TwButton
            variant={"brown-coffee"}
            // className={"w-full"}
            disabled={loadingReduxState.actionLoading}
            actionLoading={(loadingReduxState.actionLoading)}
            onClick={() => {
              cancelProductSubscription();
            }}
          >
            Cancel subscription
          </TwButton>
        </div>
      </div>
    </TwDialog>
  );
}

export function RefundClasspassDialog({
  openRefundClasspassDialog,
  setOpenRefundClasspassDialog,
  purchasingDetails,
  stripeTransactionDetails,
  myMembersDetail,
  customerInfo,
  reloadData,
}) {

  const {
    purchaseId,
    selectedPassDetail,
    paymentStatus,
    paymentMethod,
    totalStripeAmount,
  } = purchasingDetails;

  // const {
  //   amount_total,
  //   status,
  //   payment_intent,
  // } = stripeTransactionDetails;

  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userToken] = useLocalStorage("userToken");
  const dashboardReduxState = useSelector(dashboardState);
  const loadingReduxState = useSelector(loadingState);
  const [formErrors, setFormErrors] = React.useState({});
  const [formValues, setFormValues] = React.useState({
    refundAmount: parseFloat(totalStripeAmount || 0),
    refund: "no_refund",
    reason: "",
    reasonDetail: "",
  });
  const defaultrefundOptions = [
    { id: 'no_refund', value: 'no_refund', title: 'Remove with no refund' },
    // { id: 'with_refund', value: 'with_refund', title: `Remove with refund` },
  ]
  const [refundOptions, setRefundOptions] = React.useState(defaultrefundOptions);

  const getStripeInvoicePreview = async () => {

    const invoicePreviewConfig = {
      method: "post",
      url: `${getUrlForBookings()}getStripeInvoicePreview`,
      data: {
        // purchase_id: purchasingDetails._id
      }
    };
    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));

    const invoicePreviewRequest = await axiosInstance(invoicePreviewConfig);
    dispatch(setGlobalLoading(false));
    dispatch(setActionLoading(false));
    if (invoicePreviewRequest.status === 200) {
      if (invoicePreviewRequest.data.statusCode === 200 && invoicePreviewRequest.data.data.id) {
        let preview = invoicePreviewRequest.data.data
        const refundAmount = preview.total < 0 ? ((-preview.total) / 100) : 0;
        let refundOptionsList = [
          ...defaultrefundOptions,
        ]
        if (invoicePreviewRequest.data.data.latestInvoice && invoicePreviewRequest.data.data.latestInvoice.paid == true) {
          refundOptionsList.push({ id: 'pro_rated_amount', value: 'pro_rated_amount', title: `Pro-rated amount €${parseFloat(refundAmount).toFixed(2)} of €${parseFloat(totalStripeAmount).toFixed(2)}` })
        }
        setRefundOptions(refundOptionsList)
      }
    }
  };

  const removeProduct = async (data, status) => {

    const errors = {};

    if (formValues.refund == "with_refund" && formValues.refundAmount == "") {
      errors.refundAmount = "Please enter refund amount";
    } else if (formValues.refund == "with_refund" && formValues.refundAmount <= 0) {
      errors.refundAmount = "Credit must be greater than 0.";
    } else if (formValues.refund == "with_refund" && parseFloat(formValues.refundAmount) > parseFloat(totalStripeAmount)) {
      errors.refundAmount = `Refund cannot be more than €${parseFloat(totalStripeAmount).toFixed(2)}`;
    }
    if (!formValues.reason) {
      errors.reason = "Please select any one reason";
    }
    if (formValues.reason && formValues.reason == "other" && (!formValues.reasonDetail || formValues.reasonDetail.trim() == "")) {
      errors.reasonDetail = "Please write few word of your reson";
    }
    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      console.log("errors", errors);
      addErrorToast("Please fix errors below", { hideAfter: 3 });
      return;
    }

    const config = {
      method: "post",
      url: `${getUrlForBookings("")}removeProduct`,
      data: {
        purchase_id: purchasingDetails._id,
        productType: "classpass",
        refund: formValues.refund,
        customerId: customerInfo._id,
        stripeCustomer: myMembersDetail?.stripeCustomerId,
        refundAmount: formValues.refund == "with_refund" ? parseFloat(formValues.refundAmount) : 0,
        reason: formValues.reason,
        reasonDetail: formValues.reasonDetail != "" ? formValues.reasonDetail : formValues.reason,
      }
    };
    // console.log(config);
    // return;

    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const apiRequest = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    dispatch(setActionLoading(false));
    if (apiRequest.status === 200) {
      setFormErrors({})
      if (apiRequest.data.statusCode === 200) {

        addNotificationDialog({
          dialogType: "success",
          dialogTitle: "Success!",
          dialogMessage: (formValues.refund == "with_refund" ? "This product is removed/canceled and refund was initiated successfully." : "This product is removed/canceled successfully"),
          dialogBackdropClick: async () => {
            reloadData()
          },
          dialogBtnClick: async () => {
            reloadData()
          }
        })
        setOpenRefundClasspassDialog(false)
      } else {
        setFormErrors({ general: apiRequest?.data?.message || "Something is wrong please try again" })
        addErrorToast(apiRequest?.data?.message || "Something is wrong please try again")
        // addNotificationDialog({
        //   dialogType: "error",
        //   dialogTitle: "Error",
        //   dialogMessage: apiRequest.data.message,
        //   dialogBtnTitle: "Ok",
        //   dialogBackdropClick: async () => { },
        //   dialogBtnClick: async () => { }
        // })
      }
    } else {
      addErrorToast("Something is wrong please try again")
    }
  };

  useEffect(() => {

    (async () => {
      if (openRefundClasspassDialog == true) {
        let refundOptionsList = [
          ...defaultrefundOptions,
        ]
        if (paymentMethod != "Cash") {
          refundOptionsList.push({ id: 'with_refund', value: 'with_refund', title: `Remove with refund` })
        }
        setRefundOptions(refundOptionsList)
        if (selectedPassDetail.refund != undefined
          && selectedPassDetail.refund.isRefunded != undefined
          && selectedPassDetail.refund.isRefunded == true) {
          setOpenRefundClasspassDialog(false)
          addErrorToast("This multi session pass is already canceled")
        } else {
          // if (status == "Paid") {
          //   await getStripeInvoicePreview()
          // }
        }
      }

    })()
  }, [openRefundClasspassDialog, selectedPassDetail])



  return (

    <TwDialog
      dialogTitle={"Remove/Cancel Product"}
      dialogOpen={openRefundClasspassDialog}
      isFullContent={true}
      onClose={(v) => { setOpenRefundClasspassDialog(false) }}
    >
      <div className="flex flex-col w-full gap-5">

        <TwRadioBox
          // title={"Refund Type"}
          name={"refund"}
          // displayStyle="list"
          disabled={loadingReduxState.actionLoading || paymentMethod == "Cash" || paymentStatus != "Paid"}
          value={formValues.refund}
          onChange={(e) => {
            const { name, value, checked } = e.target;
            setFormValues((prevValues) => ({
              ...prevValues,
              [name]: value,
            }));
          }}
          radioList={refundOptions}
          errors={formErrors} />
        {formValues.refund == "with_refund" && (<p className="text-sm text-blue-600 flex gap-2 justify-start items-start">
          <Info className="size-10" /> Refunds take 5-10 days to appear on a customer's statement. Stripe's fees for the original payment won't be returned, but there are no additional fees for the refund.
        </p>)}
        <>
          {formValues.refund == "with_refund" && (<TwInputGroup
            label={"Refund Amount"}
            placeholder={"Refund Amount"}
            type={"number"}
            name={"refundAmount"}
            value={formValues.refundAmount}
            rightIcon={"EUR"}
            onChange={(event) => {
              setFormValues((prevValues) => ({
                ...prevValues,
                refundAmount: event.target.value,
              }));

            }}
            errors={formErrors}
          // className="!py-3 md:pl-2.5"
          // helperText=""
          />)}
          <TwSelectGroup
            label={"Reason"}
            placeholder={"Select Reason"}
            name={"reason"}
            // leftIcon={<img src={marker} alt={""} className="w-4" />}
            options={[{
              value: "", title: "Select Product...",
            }, {
              value: "duplicate", title: "Duplicate",
            }, {
              value: "fraudulent", title: "Fraudulent",
            }, {
              value: "requested_by_customer", title: "Requested By Customer",
            }, {
              value: "other", title: "Other",
            },]}
            defaultValue={formValues.reason}
            value={formValues.reason}
            onChange={(event) => {
              setFormValues((prevValues) => ({
                ...prevValues,
                reason: event.target.value,
              }));

            }}
            errors={formErrors} />
          <TwTextarea
            label={"Description"}
            name={"reasonDetail"}
            placeholder={
              formValues.reason == "other" ? "" : "Optional"
            }
            value={formValues.reasonDetail}
            row={3} onChange={(event) => {
              setFormValues((prevValues) => ({
                ...prevValues,
                reasonDetail: event.target.value,
              }));

            }}
            errors={formErrors}
          />
        </>
        {formErrors["general"] && (
          <TwFormHelperText error={true}>{formErrors["general"]}</TwFormHelperText>
        )}
        <div className={"flex gap-4 justify-center pt-5 w-full sm:w-full sm:max-w-sm md:max-w-lg"}>
          <TwButton
            variant={"brown-coffee-outline"}
            // className={"w-full"}
            disabled={loadingReduxState.actionLoading}
            onClick={() => {
              setOpenRefundClasspassDialog(false)
            }}
          >
            Cancel
          </TwButton>
          <TwButton
            variant={"brown-coffee"}
            // className={"w-full"}
            disabled={loadingReduxState.actionLoading}
            actionLoading={(loadingReduxState.actionLoading)}
            onClick={() => {
              removeProduct();
            }}
          >
            {formValues.refund == "with_refund" ? "Remove & Refund" : "Remove"}
          </TwButton>
        </div>
      </div>
    </TwDialog>
  );
}
